import React from 'react';
import Logo from "../assets/images/rabta logo.png";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="not-found-container main-bg">
            <div className="pattern-header"></div>

            <div className="scalloped-frame congrats-page">
                <div className="content-area">
                    <div className="logo">
                        <img src={Logo} alt="logo" className="logo-main" />
                    </div>


                    <h2 className="error-code">404</h2>
                    <p className="error-message">Page Not Found</p>
                    <br />
                    <p className="error-description">
                        Oops! The page you're looking for seems to have wandered off.<br />
                        Let's get you back on track.
                    </p>
                    <br />
                    <Link to="/" className="btn-home" style={{ width: 'fit-content', margin: 0 }}>
                        Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
}